<template>
  <div class="position-r box">
    <!--banner-->
    <div class="index-banner" @click="goToUrl"></div>
    <div class="flexJC p15">
      <div class="user-box">
        <div class="photo-icon">
          <img :src="headPhoto" alt="" class="head-img" />
        </div>
        <div class="userInfo text-left">
          <div class="flex-fs text-over">
            <i class="icon-con icon_lb"></i>
            <h4 class="color-3 f18 mt-3 flex text-over">欢迎使用爱格汇共享轮椅</h4>
          </div>
          <p class="pt5 f12 color-66">支付宝名：{{userName}}</p>
        </div>
      </div>

      <div class="pt30">
        <div class="flex-fs">
          <i class="icon-con icon_lb icon-fy"></i>
          <h3 class="f16 fw color-9 mt-3">温馨提示</h3>
        </div>
        <div class="content-box">
          <div class="flexJC alignItem fw">
            <div class="f16 color-2" v-show="isNormal !== 1">设备不在线</div>
            <div class="f16 color-2" v-show="isNormal == 1 && tag == true">
              <p>请麻烦帮忙关闭柜门再继续</p>
              <p class="mt5">谢谢您的合作</p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="p15">
      <button class="btn-con btn-color btn-width mb10" @click="nextFun">继续</button>
      <a href="tel:400-688-9528" class="btn-con btn-color btn-width" v-if="isNormal == 3 || isNormal == 5">联系客服</a>
    </div>
    <!--弹框-->
    <div class="shade" v-show="isLoading">
      <div class="flexJC alignItem showLoading">
        <img src="../../../static/images/Spinner_1.gif" alt="" class="icon_loading" />
      </div>
    </div>
  </div>
</template>

<script>
import wxServ from '../../service/wxServ'
import cache from '../../service/cacheServ'
import userServ from '../../service/userServ'
import mintUi from '../../lib/mint-ui'
import cabinetServ from '../../service/cabinetServ'
export default {
  data() {
    return {
      headPhoto: '/static/images/touxiang@2x.png',
      userName: '',
      isLoading: false,
      isNormal: null,
      tag: false,
      qrCode: null,
      bedNo: null,
      wxId: null
    }
  },
  created() {
    let qrCode = this.$route.query.qrcode
    console.log('qrCode:' + this.$route.query.qrcode)
    this.qrCode = qrCode
    this.bedNo = this.$router.query.bedNo;
    let userInfo = cache.get('user');
    if (userInfo && qrCode) {
      this.userName = userInfo.customerName;
      this.headPhoto = userInfo.headImgUrl ? userInfo.headImgUrl : '/static/images/touxiang@2x.png';
      this.wxId = userInfo.openId;
      this.getCabinetSta(this.qrCode)
    }
  },
  methods: {
    // 获取设备状态
    getCabinetSta(qrCode) {
      let that = this;
      this.isLoading = true;
      cabinetServ.getCabinetStatus(qrCode).then(res => {
        this.isLoading = false;
        if (res.code === '200') {
          if (!res.data) {

          } else {
            this.cabinetInfo = res.data;
            cache.set('cabinetInfo', res.data, true);
            if (res.data.status === '2') { // 设备正常
              this.isNormal = 1;
              let doorList = res.data.doorStatus;
              let newList = doorList.filter(item => item != 1);// 过滤掉当其中有一个门打开时
              console.log(newList);
              if (newList.length > 0) {
                this.tag = true
              } else {
                this.tag = false;
                this.$router.push({ path: '/alipayIndex', query: { qrcode: qrCode, bedNo: that.bedNo } })
              }
            } else if (res.data.status === '3') { // 设备离线
              this.isNormal = 2
            } else if (res.data.status === 'null') { // 设备不在线
              this.isNormal = 5
            } else {
              this.isNormal = 3
            }
          }
        } else {
          this.isNormal = 4
          mintUi.Toast({
            message: res.message,
            position: 'bottom'
          })
        }
      })
    },
    nextFun() {
      this.getCabinetSta(this.qrCode)
    },
    goToUrl() {
      window.location.href = 'http://www.aigehui028.com/'
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
@import "../../less/_var.less";
@import "../../less/index.less";
.index-banner {
  height: 136px;
  width: 100%;
  background: url("../../../static/images/header_logo.jpg") no-repeat;
  background-size: 100% 100%;
  display: block;
}
.pt5 {
  padding-top: 5px;
}
.loadingImg {
  width: 100px;
  height: 100px;
}
.loading-con {
  width: 70%;
  margin-left: -35%;
}
.photo-icon {
  position: absolute;
  top: -10px;
  left: 16px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
}
.photo-icon img {
  width: 100%;
  height: 100%;
}
.userInfo {
  position: absolute;
  left: 90px;
  top: 15px;
  right: 16px;
}
.icon_lb {
  background: url("../../../static/images/icon_tz.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.icon-fy {
  background: url("../../../static/images/icon_fy.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.mt-3 {
  margin-top: -3px;
}
.icon-sb {
  background: url("../../../static/images/icon_sb.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.icon_loading {
  width: 60px;
  height: 60px;
}
.btn-width {
  width: 100%;
}
.head-img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/alipay/alipayStatus.vue